import { clarity } from 'react-microsoft-clarity';

export const initializeClarity = () => {
  clarity.init('h0ofeuxjrw');
};
